import {defineMessages} from 'react-intl';

const messages = defineMessages({
    NO_RIGHTS: {
        id: 'mainPage.welcome.noRights',
        defaultMessage: 'Your user has no rights for the application. Please contact your admin to assign some rights for you.'
    }
});

export default messages;
